const OMSCardData = [
  {
    card1up1: "200",
    card1up2: "Active",
    card1up3: "20439 orders placed",
    card1dnP: "TOTAL ORDERS",
    dot1: "Active orders",
    dot2: "Completed",
  },
  {
    card1up1: "10",
    card1up2: "Remaining",
    card1up3: "20439 orders online",
    card1dnP: "ORDER STATUS",
    dot1: "Delivered",
    dot2: "Dispatched",
    dot3: "Ongoing",
    dot4: "Returned",
  },
  {
    card1up1: "1688",
    card1up2: "Units Sold",
    card1up3: "2890 sold last month",
    card1dnP: "SALES",
    gain:-10.5,
  },
  {
    card1up1: "Rs. 443410",
    card1up2: "Earned",
    card1up3: "Rs. 2L more than last month",
    card1dnP: "PROFIT",
    gain:+33.4,
  },
  {
    card1up1: "1340",
    card1up2: "Items Left",
    card1up3: "Out of 1500 added till now",
    card1dnP: "ITEMS",
    gain:+15,
  },
  {
    card1up1: "3",
    card1up2: "Platforms",
    card1up3: "since 21.06.2022",
    card1dnP: "PLATFORMS",
  },
];

const BICardData = [
  {
    card1up1: "1400",
    card1up2: "total orders",
    card1up3: "20439 orders placed",
    card1dnP: "TOP 2 CATEGORIES",
    dot1: "Category 1",
    dot2: "Category 2",
  },
  {
    card1up1: "10%",
    card1up2: "growth on overall business",
    card1up3: "20439 orders online",
    card1dnP: "INHOUSE PROFIT",
  },
  { 
    card1up1: "5",
    card1up2: "Days",
    card1up3: "Highest: 10, Lowest:2",
    card1dnP: "AVERAGE DELIVERY",
  },
  {
    card1up1: "Rs. 1,23,000",
    card1up2: "Cash Invested",
    card1up3: "3.2% less than the last month",
    card1dnP: "ADS STATS",
    gain:+21,
  },
  {
    card1up1: "94.5%",
    card1up2: "20 Orders",
    card1up3: "3.2% less than the last month",
    card1dnP: "PERFECT ORDER RATE",
    gain:-10,

  },
  {
    card1up1: "2.5:1",
    card1up2: "vs last 30 days",
    card1up3: "1.8% more than the last month",
    card1dnP: "PLATFORMS",
    gain:+6.8,

  },
];

const InventoryCardData = [
  {
    card1up1: "42000",
    card1up2: "Products",
    card1up3: "2000 available Products",
    card1dnP: "TOTAL Products",
  },
  {
    card1up1: "50",
    card1up2: "Categories",
    card1up3: "since 22.01.2020",
    card1dnP: "CATEGORIES",
    gain:+3,
  },
  {
    card1up1: "Rs. 443410",
    card1up2: "Total Worth",
    card1up3: "Rs. 2L increased since last month",
    card1dnP: "PRODUCTS WORTH",
    gain:+13.4,
  },
  {
    card1up1: "200",
    card1up2: "Items sold per day",
    card1up3: "Highest: 700 items sold",
    card1dnP: "ITEMS SOLD",
  },
  {
    card1up1: "30",
    card1up2: "products added recently",
    card1up3: "on 20.03.2022",
    card1dnP: "PRODUCTS ADDED",
  },
  {
    card1up1: "3",
    card1up2: "warehouses",
    card1up3: "since 22.01.2020",
    card1dnP: "WAREHOUSES",
  },
];
const WarehouseCardData = [
  {
    card1up1: "3",
    card1up2: "Warehouses",
    card1up3: "40000 products in total",
    card1dnP: "WAREHOUSES",
  },
  {
    card1up1: "12",
    card1up2: "Departments",
    card1up3: "4 Added last month",
    card1dnP: "DEPARTMENTS", 
    gain:+4,
  },
  {
    card1up1: "Rs. 3000000",
    card1up2: "Total Worth",
    card1up3: "Rs 10L increased since last month",
    card1dnP: "NET WORTH",
    gain:20,
  },
  {
    card1up1: "300",
    card1up2: "average shipping per day",
    card1up3: "Higest: 800 items",
    card1dnP: "AVERAGE SHIPPING",

  },
  {
    card1up1: "200",
    card1up2: "workers in warehouses",
    card1up3: "last edited on 20.03.2022",
    card1dnP: "TOTAL WORKERS",
    gain:+10,
  },
  {
    card1up1: "Rs. 40000",
    card1up2: "items overall",
    card1up3: "since 22.01.2022",
    card1dnP: "OVERALL ITEMS",
  },
];
const CRMCardData = [ 
  {
    card1up1: "35%",
    card1up2: "New Customers",
    card1up3: "2439 customers online",
    card1dnP: "CUSTOMER RATIO",
    dot1: "Total",
    dot2: "Returning",
    dot3: "New",
    dot4: "Left",
  },
  {
    card1up1: "78%",
    card1up2: "Visitors turned",
    card1up3: "454 visitors turned into customers",
    card1dnP: "CONVERSION RATE",
    gain:+20,
  },
  {
    card1up1: "Rs. 22890",
    card1up2: "Avg. customer lifetime value",
    card1up3: "Rs 2890 loss to be generated",
    card1dnP: "CLV",
    gain:-10.5,
  },
  {
    card1up1: "48%",
    card1up2: "customers purchase twice",
    card1up3: "2400 customers purchase twice",
    card1dnP: "REPEAT PURCHASE RATE",
    gain:+20,
  },
  {
    card1up1: "35%",
    card1up2: "promoters",
    card1up3: "169 customers less than last month",
    card1dnP: "NPS",
    gain:-10,
  },
  {
    card1up1: "35%",
    card1up2: "first time order",
    card1up3: "20439 orders online",
    card1dnP: "ORDER RATIO",
    dot1: "Cart Abandoned",
    dot2: "Repeated",
    dot3: "First Time",
    dot4: "Returned",
  },
];
const DropShipCardData = [
  {
    card1up1: "359",
    card1up2: "Orders",
    card1up3: "20239 orders placed",
    card1dnP: "ORDERS TODAY",
  },
  {
    card1up1: "1211",
    card1up2: "orders",
    card1up3: "68% orders are fulfilled",
    card1dnP: "ORDER FILL RATE",
    dot1: "Total",
    dot2: "Partially fulfilled",
    dot3: "Fulfilled",
    dot4: "Pending",
  },
  {
    card1up1: "87%",
    card1up2: "within the time limit", 
    card1up3: "10% more than last month",
    card1dnP: "SHIPMENT TIME",
    dot1: "549 orders",
    dot2: "73 orders",
  },
  {
    card1up1: "78",
    card1up2: "suppliers available",
    card1up3: "",
    card1dnP: "NO OF SUPPLIERS",
    dot1: "India",
    dot2: "Gurugram",
    dot3: "Delhi",
    dot4: "Mumbai",
  },
  {
    card1up1: "5.5%",
    card1up2: "38 orders",
    card1up3: "3.2% less than last month",
    card1dnP: "BACK ORDER RATE",
    gain:+20,
  },
  {
    card1up1: "94.5%",
    card1up2: "20 orders",
    card1up3: "3.2% less than last month",
    card1dnP: "PERFECT ORDER RATE",
    gain:-10,
  },
];
const FinanceCardData = [
  {
    card1up1: "₹1.5L",
    card1up2: "from 9.5k",
    card1up3: "30% more than last month",
    card1dnP: "TOTAL GROSS REVENUE",
  },
  {
    card1up1: "75%",
    card1up2: "by product type",
    card1up3: "10% more than last month",
    card1dnP: "GROSS MARGIN",
  },
  {
    card1up1: "₹1839",
    card1up2: "from ₹1739", 
    card1dnP: "REVENUE PER USER",
    gain:8.9,
  },
  {
    card1up1: "₹399",
    card1up2: "from ₹319",
    card1dnP: "REVENUE PER VISTOR",
    gain:+20,
  },
  {
    card1up1: "₹416",
    card1up2: "per site visit",
    card1up4: "₹184 less than last month",
    card1dnP: "COST PER VISITOR",
    gain:+25,
  },
  {
    card1up1: "₹30K",
    card1up2: "has been spend on marketing",
    card1up3: "₹10K less than FY2021",
    card1dnP: "MARKETING SPEND",
  },
];
const AccountCardData = [
  {
    card1up1: "9.87",
    card1up2: "from 8.92",
    card1up3: "No overdue bills left",
    card1dnP: "DAYS PAYABLE OUTSTANDING",
  },
  {
    card1up1: "₹268",
    card1up2: "from receipt to payment",
    card1up3: "₹58 less than last month",
    card1dnP: "COST PER INVOICE",
  },
  {
    card1up1: "14 Days",
    card1up2: "from 1st Jul to 15th Jul", 
    card1up3: "3 days less than last cycle",
    card1dnP: "INVOICE CYCLE TIME",
  },
  {
    card1up1: "6.4 Days",
    card1up2: "from 23rd Jul to 31st Jul",
    card1up3: "1 day less than month",
    card1dnP: "MONTHLY CLOSING PERIOD",

  },
  {
    card1up1: "24 Days",
    card1up2: "from 6th Apr to 30th Apr",
    card1up3: "3 day less than last fiscal year",
    card1dnP: "ANNUAL CLOSING PERIOD",
  },
];

export { OMSCardData };
export { InventoryCardData };
export { WarehouseCardData };
export { CRMCardData };
export { DropShipCardData };
export { FinanceCardData };
export { AccountCardData };
export { BICardData }
